import React from 'react';
import { Table } from 'semantic-ui-react';
import { ColumnDefinition } from '../../interfaces/ColumnDefinition';
import { ActionsProps } from '../../interfaces/TableActionsProps';
import TableHeader from '../TableHeader';
import TableCell from '../TableCell';
import { TableActions } from '../TableActions/TableActions';

import './TableRowSubItems.less';

interface Props<TData, TField> {
  items: TData[];
  columnDefinitionsLength: number;
  isMainRowHasActions: boolean;
  columnDefinitionsSubItem: ColumnDefinition<TData, TField, any>[];
  expandableRowContent?: (rowData: TData) => React.ReactElement;
  getId: (item: TData) => string;
  checkedItems?: number;
  showCheckButton?: 'box' | 'radio' | boolean;
  actions?: ActionsProps<TData>;
  showArrowForRowWithSubItems?: boolean;
  showTableHeadForSubItems?: boolean;
}

export const TableRowSubItems = <TData, TField>(
  props: Props<TData, TField>
) => {
  if (!props.columnDefinitionsSubItem.length) return null;

  const mainRowTdCount =
    props.columnDefinitionsLength + +props.isMainRowHasActions;
  const subItemsRowTdCount =
    props.columnDefinitionsSubItem.length + +(props.actions !== undefined);

  const getRows = (isCustomTable = false) =>
    props.items.map((item) => {
      return (
        <Table.Row key={props.getId(item)} className="p-os-table-row-subitems">
          {!isCustomTable && props.showArrowForRowWithSubItems && (
            <Table.Cell />
          )}
          {!isCustomTable && props.showCheckButton && <Table.Cell />}
          {props.columnDefinitionsSubItem.map((columnDefinition) => (
            <TableCell
              key={props.getId(item) + '_' + columnDefinition.name}
              columnDefinition={columnDefinition}
              getId={props.getId}
              item={item}
            />
          ))}
          {props.actions && (
            <Table.Cell width={1}>
              <TableActions
                checkedItems={props.checkedItems}
                item={item}
                {...props.actions}
              />
            </Table.Cell>
          )}
        </Table.Row>
      );
    });

  if (
    mainRowTdCount === subItemsRowTdCount &&
    !props.showTableHeadForSubItems
  ) {
    return <>{getRows()}</>;
  }

  return (
    <Table.Row className="p-os-table-row-subitems p-os-table-row-subitems-no-hover">
      {props.showArrowForRowWithSubItems && (
        <Table.Cell className="p-os-table-row-subitems-wrapper-cell" />
      )}
      {props.showCheckButton && (
        <Table.Cell className="p-os-table-row-subitems-wrapper-cell" />
      )}
      <Table.Cell
        className="p-os-table-row-subitems-wrapper-cell"
        colSpan={mainRowTdCount}
      >
        <Table>
          {props.showTableHeadForSubItems && (
            <TableHeader
              columnDefinitions={props.columnDefinitionsSubItem}
              handleSort={() => null}
            />
          )}
          <Table.Body>{getRows(true)}</Table.Body>
        </Table>
      </Table.Cell>
    </Table.Row>
  );
};
